import { render, staticRenderFns } from "./NotifyBar.vue?vue&type=template&id=1317952d&"
import script from "./NotifyBar.vue?vue&type=script&lang=js&"
export * from "./NotifyBar.vue?vue&type=script&lang=js&"
import style0 from "./NotifyBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports